"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const models_1 = require("../models");
class Notification {
    constructor(_messageType, _targetId, _chatId) {
        this._messageType = _messageType;
        this._targetId = _targetId;
        this._chatId = _chatId;
    }
    get priority() {
        switch (this.messageType) {
            case models_1.MESSAGE_TYPE.PRIORITY:
                return 1;
            case models_1.MESSAGE_TYPE.ACKNOWLEDGE:
                return 2;
            default:
                return 3;
        }
    }
    get messageType() {
        return this._messageType;
    }
    get targetId() {
        return this._targetId;
    }
    get chatId() {
        return this._chatId;
    }
}
exports.Notification = Notification;
